import { createFileRoute } from "@tanstack/react-router";
import { HandheldPage } from "@/features/handheld/handheld-page";

/**
 * Public, like "/" and /login, so it lives outside `_app`: a handheld opens it to install the app
 * before it has an account. This is the address handed out on the floor.
 *
 * It is a directory route (`app/index.tsx`) rather than `app.tsx` on purpose: the generator strips
 * the layout prefix from `_app.tsx`, so a file named `app.tsx` would emit a second `AppRoute` and
 * the route tree would not compile.
 */
export const Route = createFileRoute("/app/")({
  component: HandheldPage,
});
